import { useApp } from "@/contexts/AppContext";
import * as L from "lucide-react";

export default function CategoryFilter() {
  const { categories, category, setCategory } = useApp();
  const all = [{ name: "All", icon: "Sparkles", color: "#F59E0B" }, ...categories];
  return (
    <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-11 gap-3" data-testid="category-filter">
      {all.map((c) => {
        const Icon = L[c.icon] || L.Sparkles;
        const active = category === c.name;
        return (
          <button
            key={c.name}
            data-testid={`category-${c.name}`}
            onClick={() => setCategory(c.name)}
            className={`group flex flex-col items-center gap-2 p-3 rounded-2xl border transition-all ${
              active ? "border-primary bg-primary/10" : "border-border hover:border-primary/40 hover:-translate-y-0.5"
            }`}
          >
            <span
              className="inline-flex h-11 w-11 items-center justify-center rounded-xl"
              style={{ backgroundColor: `${c.color}22`, color: c.color }}
            >
              <Icon className="h-5 w-5" />
            </span>
            <span className="text-xs font-semibold">{c.name}</span>
          </button>
        );
      })}
    </div>
  );
}
